module.exports = __webpack_public_path__ + "img/image4.057384a4.svg";